import styled from 'styled-components'

const ContentDiv = styled.div`
  margin: 50px 15px 0px;
  flex: 1;
  overflow-y: scroll;
`;

export const FullPageDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  position: fixed;
`;

export default ContentDiv
